import { useEffect, useState, useMemo, useCallback } from "react"
import { useRecoilState } from "recoil"

import { dealerInfo } from "../../atoms/DealerAtom"
import { primeConsultant } from "../../atoms/primeConsultant.js"
import check from "../../assets/images/check.svg"
import Support from "./Support"
import HistoricalIngestionRequest from "./HistoricalIngestionRequest"
import CollapsingButton from "../../components/Fields/CollapsingButton"
import { CollapseRightBar } from "../../atoms/SideBars"

import supportIcon from "../../assets/images/reset.png"
import {
  getApiHelper,
  patchApiHelper,
  persistBigQueryDealerId,
} from "../../util/apiHelpers.js"

export default function Connect() {
  const [users, setUsers] = useState([])
  const [dealerGroups, setDealerGroups] = useState([])
  const [userID, setUserID] = useState(0)
  const [dealerInfoValue, setDealerInfoValue] = useRecoilState(dealerInfo)
  const [dealerConnections, setDealerConnections] = useState({
    crmCompanyID: dealerInfoValue.crmCompanyID,
    googleAnalyticsGTMID: dealerInfoValue.googleAnalytics_GTM_ID,
    webStreamID: dealerInfoValue.webStreamID,
    dashThisURL: dealerInfoValue.dashThisURL,
    dealerVaultID: dealerInfoValue.rooftopID,
    fbPageID: dealerInfoValue.fb_page_id,
    fbaDaccountID: dealerInfoValue.fbaDaccountID,
    dvDataSource: dealerInfoValue.dvDataSource,
    fortellisID: dealerInfoValue.fortellisID,
  })
  const [success, setSuccess] = useState(false)
  const [fortellisCheck, setFortellisCheck] = useState(null) // null | 'available' | 'taken' | 'checking' | 'generating'
  const [rooftopCheck, setRooftopCheck] = useState(null) // null | 'available' | 'taken' | 'checking' | 'generating'
  const rightMenuCollapse = useRecoilState(CollapseRightBar)[0]
  const [, setPrimeCon] = useRecoilState(primeConsultant)
  const [dealerGroupID, setDealerGroupID] = useState(
    dealerInfoValue.dealerGroup.dealerGroupID
  )

  const rols = ["Business", "Business Free"]

  const getUsers = () => {
    getApiHelper(`Users`)
      .then((res) => setUsers(res.data))
      .catch((error) => console.log(error))
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    setDealerConnections({ ...dealerConnections, [name]: value })
    if (name === "fortellisID") setFortellisCheck(null)
    if (name === "dealerVaultID") setRooftopCheck(null)
  }

  const checkFortellisAvailability = useCallback(() => {
    const id = dealerConnections.fortellisID
    if (!id || id.trim() === "") return
    setFortellisCheck("checking")
    getApiHelper(`Dealers/CheckFortellisID/${encodeURIComponent(id.trim())}`)
      .then((res) => {
        const available = res?.data?.available
        setFortellisCheck(
          available === true
            ? "available"
            : available === false
            ? "taken"
            : null
        )
      })
      .catch(() => setFortellisCheck(null))
  }, [dealerConnections.fortellisID])

  const generateFortellisID = useCallback(() => {
    setFortellisCheck("generating")
    getApiHelper(`Dealers/GenerateFortellisID`)
      .then((res) => {
        const newId = res?.data?.newId
        if (newId) {
          setDealerConnections((prev) => ({ ...prev, fortellisID: newId }))
          setFortellisCheck("available")
        } else {
          setFortellisCheck(null)
        }
      })
      .catch(() => setFortellisCheck(null))
  }, [])

  const checkRooftopAvailability = useCallback(() => {
    const id = dealerConnections.dealerVaultID
    if (!id || id.trim() === "") return
    setRooftopCheck("checking")
    const excludeID = dealerInfoValue.dealerID ?? 0
    getApiHelper(
      `Dealers/CheckRooftopID/${encodeURIComponent(
        id.trim()
      )}?excludeDealerID=${excludeID}`
    )
      .then((res) => {
        const available = res?.data?.available
        setRooftopCheck(
          available === true
            ? "available"
            : available === false
            ? "taken"
            : null
        )
      })
      .catch(() => setRooftopCheck(null))
  }, [dealerConnections.dealerVaultID, dealerInfoValue.dealerID])

  const generateNextFTL = useCallback(() => {
    setRooftopCheck("generating")
    getApiHelper(`Dealers/NextFTLRooftopID`)
      .then((res) => {
        const nextId = res?.data?.nextId
        if (nextId) {
          setDealerConnections((prev) => ({ ...prev, dealerVaultID: nextId }))
          setRooftopCheck("available")
        } else {
          setRooftopCheck(null)
        }
      })
      .catch(() => setRooftopCheck(null))
  }, [])

  const generateNextDVD = useCallback(() => {
    setRooftopCheck("generating")
    getApiHelper(`Dealers/NextDVDRooftopID`)
      .then((res) => {
        const nextId = res?.data?.nextId
        if (nextId) {
          setDealerConnections((prev) => ({ ...prev, dealerVaultID: nextId }))
          setRooftopCheck("available")
        } else {
          setRooftopCheck(null)
        }
      })
      .catch(() => setRooftopCheck(null))
  }, [])
  const submit = () => {
    const formData = new FormData()
    formData.append("DealerID", dealerInfoValue.dealerID)
    formData.append("CrmCompanyID", dealerConnections.crmCompanyID)
    formData.append(
      "GoogleAnalytics_GTM_ID",
      dealerConnections.googleAnalyticsGTMID
    )
    formData.append("WebStreamID", dealerConnections.webStreamID)
    formData.append("DashThisURL", dealerConnections.dashThisURL)
    formData.append("RoofTopID", dealerConnections.dealerVaultID)
    formData.append("ProgramID", "DVV01397")
    formData.append("fb_page_id", dealerConnections.fbPageID)
    formData.append("fbad_account_id", dealerConnections.fbaDaccountID)
    formData.append("dvDataSource", dealerConnections.dvDataSource)
    formData.append("fortellisID", dealerConnections.fortellisID)
    patchApiHelper(`Dealers`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(true)
          setTimeout(() => {
            setSuccess(false)
          }, 10000)
        }
      })
      .catch((error) => console.log(error))
  }

  const getDealerGroups = () => {
    getApiHelper(`DealerGroups`)
      .then((res) => setDealerGroups(res.data))
      .catch((error) => console.log(error))
  }

  const updatePrimeConsultant = (userID) => {
    const updatePrime = {
      dealer_id: dealerInfoValue.dealerID,
      user_id: userID,
    }

    patchApiHelper(`dealers/primary-consultant/`, updatePrime)
      .then((response) => {
        if (response.status !== 200) {
          alert("Error updating primary consultant")
        } else {
          setPrimeCon(response.data)
          setSuccess(true)
          setTimeout(() => {
            setSuccess(false)
          }, 10000)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    getUsers()
    getDealerGroups()
  }, [])

  const handleConnectDealerGroup = () => {
    const formData = new FormData()
    formData.append("DealerID", dealerInfoValue.dealerID)
    formData.append("DealerGroupID", dealerGroupID)
    formData.append("BusinessName", dealerInfoValue.businessName)
    formData.append("Address", dealerInfoValue.address)
    formData.append("Address2", dealerInfoValue.address2)
    formData.append("City", dealerInfoValue.city)
    formData.append("ZipCode", dealerInfoValue.zipCode)
    formData.append("State", dealerInfoValue.state)
    formData.append("BusinessLogo", dealerInfoValue.businessLogoUrl)
    formData.append("ProfileStatus", dealerInfoValue.profileStatus)
    formData.append("CrmCompanyID", dealerInfoValue.crmCompanyID)
    formData.append("TierLevel", dealerInfoValue.tierLevel)
    formData.append("CrmCompanyUrl", dealerInfoValue.crmCompanyUrl)
    patchApiHelper(`Dealers`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          alert("Error updating dealer")
        } else {
          setDealerInfoValue(response.data)
          persistBigQueryDealerId(response.data)
          setSuccess(true)
          setTimeout(() => {
            setSuccess(false)
          }, 10000)
        }
      })
      .catch((error) => console.log(error))
  }

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      return !user.role.roleName.includes(rols)
    })
  }, [users])

  return (
    <div className="flex bg-[#F5F9FF] rounded-xl">
      <div className="grid col-span-5 2xl:text-[14px] text-[12px] rounded-l-xl p-4 w-[83%] grow">
        {success ? (
          <div className="flex w-full justify-center">
            <div className="bg-[#E57200] py-2 rounded-md flex justify-center mb-4 w-[550px]">
              <img className="mx-2 pt-[4px] h-[85%]" src={check} alt="check" />
              <h3 className="text-white font-bold text-[15px]">
                Your connection was saved successfully.
              </h3>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="flex flex-col items-center justify-start">
          <div className="grid grid-cols-12 mb-[12px] w-full items-center">
            <h3 className="grid col-span-1 font-bold text-[#586283]">
              Platform ID:
            </h3>
            <h4 className="grid col-span-11 ml-[15px]">9380008811</h4>
          </div>
          <h3 className="font-bold text-[#586283] text-[20px] my-[20px]">
            Connect This Profile
          </h3>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              QuickBooks Account #
            </h3>
            <select className="rounded-xl w-[400px] p-[16px] focus:outline-[#58628325] ml-[15px] focus:border-none">
              <option value="" selected="selected">
                Select a QuickBooks Account #
              </option>
            </select>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              HubSpot Company ID #
            </h3>
            <input
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
              name="crmCompanyID"
              onChange={handleChange}
              value={
                dealerConnections.crmCompanyID
                  ? dealerConnections.crmCompanyID
                  : ""
              }
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              Google Analytics GTM ID
            </h3>
            <input
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
              name="googleAnalyticsGTMID"
              onChange={handleChange}
              value={
                dealerConnections.googleAnalyticsGTMID
                  ? dealerConnections.googleAnalyticsGTMID
                  : ""
              }
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              Web Stream ID
            </h3>
            <input
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
              name="webStreamID"
              onChange={handleChange}
              value={
                dealerConnections.webStreamID
                  ? dealerConnections.webStreamID
                  : ""
              }
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              Facebook Page ID #
            </h3>
            <input
              name="fbPageID"
              onChange={handleChange}
              value={
                dealerConnections.fbPageID ? dealerConnections.fbPageID : ""
              }
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              Facebook Account ID #
            </h3>
            <input
              name="fbaDaccountID"
              onChange={handleChange}
              value={
                dealerConnections.fbaDaccountID
                  ? dealerConnections.fbaDaccountID
                  : ""
              }
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              DashThis URL
            </h3>
            <input
              className="grid col-span-10 rounded-xl w-[80%] p-[16px]  focus:outline-[#58628325] ml-[15px]"
              name="dashThisURL"
              onChange={handleChange}
              value={
                dealerConnections.dashThisURL
                  ? dealerConnections.dashThisURL
                  : ""
              }
            ></input>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              DealerVault ID #
            </h3>
            <div className="grid col-span-10 ml-[15px] flex flex-col gap-1">
              <div className="flex items-center gap-2 w-[80%]">
                <input
                  name="dealerVaultID"
                  onChange={handleChange}
                  value={dealerConnections.dealerVaultID ?? ""}
                  className="flex-1 rounded-xl p-[16px] focus:outline-[#58628325]"
                />
                <button
                  type="button"
                  onClick={checkRooftopAvailability}
                  disabled={
                    !dealerConnections.dealerVaultID ||
                    rooftopCheck === "checking"
                  }
                  title="Check if this ID is available"
                  className="flex-shrink-0 rounded-lg px-3 py-2 text-[11px] font-semibold border border-[#298FC2] text-[#298FC2] hover:bg-[#298FC2] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  {rooftopCheck === "checking" ? "..." : "Check"}
                </button>
                <button
                  type="button"
                  onClick={generateNextFTL}
                  disabled={rooftopCheck === "generating"}
                  title="Auto-fill the next available FTL ID"
                  className="flex-shrink-0 rounded-lg px-3 py-2 text-[11px] font-semibold border border-[#586283] text-[#586283] hover:bg-[#586283] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  {rooftopCheck === "generating" ? "..." : "Next FTL"}
                </button>
                <button
                  type="button"
                  onClick={generateNextDVD}
                  disabled={rooftopCheck === "generating"}
                  title="Auto-fill the next available DVD ID"
                  className="flex-shrink-0 rounded-lg px-3 py-2 text-[11px] font-semibold border border-[#586283] text-[#586283] hover:bg-[#586283] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  {rooftopCheck === "generating" ? "..." : "Next DVD"}
                </button>
              </div>
              {rooftopCheck === "available" && (
                <span className="text-[11px] text-green-600 font-medium pl-1">
                  ✓ ID available
                </span>
              )}
              {rooftopCheck === "taken" && (
                <span className="text-[11px] text-red-500 font-medium pl-1">
                  ✗ ID already in use — try a different one or generate a new
                  one
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              Fortellis ID #
            </h3>
            <div className="grid col-span-10 ml-[15px] flex flex-col gap-1">
              <div className="flex items-center gap-2 w-[80%]">
                <input
                  name="fortellisID"
                  onChange={handleChange}
                  value={dealerConnections.fortellisID ?? ""}
                  className="flex-1 rounded-xl p-[16px] focus:outline-[#58628325]"
                />
                <button
                  type="button"
                  onClick={checkFortellisAvailability}
                  disabled={
                    !dealerConnections.fortellisID ||
                    fortellisCheck === "checking"
                  }
                  title="Check if this ID is available"
                  className="flex-shrink-0 rounded-lg px-3 py-2 text-[11px] font-semibold border border-[#298FC2] text-[#298FC2] hover:bg-[#298FC2] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  {fortellisCheck === "checking" ? "..." : "Check"}
                </button>
                <button
                  type="button"
                  onClick={generateFortellisID}
                  disabled={fortellisCheck === "generating"}
                  title="Generate a new unique Fortellis GUID"
                  className="flex-shrink-0 rounded-lg px-3 py-2 text-[11px] font-semibold border border-[#586283] text-[#586283] hover:bg-[#586283] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  {fortellisCheck === "generating" ? "..." : "Generate"}
                </button>
              </div>
              {fortellisCheck === "available" && (
                <span className="text-[11px] text-green-600 font-medium pl-1">
                  ✓ ID available
                </span>
              )}
              {fortellisCheck === "taken" && (
                <span className="text-[11px] text-red-500 font-medium pl-1">
                  ✗ ID already in use — generate a new one
                </span>
              )}
            </div>
          </div>
          <HistoricalIngestionRequest
            dealerID={dealerInfoValue.dealerID}
            fortellisID={dealerInfoValue.fortellisID}
          />
          <div className="grid grid-cols-12 mb-[12px] justify-start w-full items-center">
            <h3 className="grid col-span-2 font-bold text-[#586283]">
              DealerVault Data Source
            </h3>
            <select
              name="dvDataSource"
              onChange={handleChange}
              value={dealerConnections.dvDataSource}
              className="rounded-xl w-[400px] p-[16px] focus:outline-[#58628325] ml-[15px] focus:border-none"
            >
              <option value="0">Not Required</option>
              <option value="1">Dealer OMG - API Dealervault</option>
              <option value="2">Manning Agency - FTP Dealervault</option>
            </select>
          </div>
          <div className="flex flex-row mb-[12px] justify-center w-full">
            <button
              onClick={submit}
              className="flex items-center w-[103px] justify-around text-white bg-[#298FC2] focus:ring-4 font-bold rounded-lg text-sm px-5 py-2.5 text-center mr-2 my-2"
            >
              Submit
            </button>
          </div>
        </div>
        <div className="">
          <h3 className="font-bold text-[#586283] text-[20px] my-[20px]">
            Connect to a Dealer Group profile:
          </h3>
          <div className="flex flex-row items-center justify-around w-[800px] space-y-6">
            <h3>Dealer Group</h3>
            <select
              onChange={(e) => setDealerGroupID(e.target.value)}
              value={dealerGroupID}
              className="rounded-xl w-[400px] p-[16px] focus:outline-[#58628325] ml-[15px] focus:border-none"
            >
              {dealerGroups.map((dealergroup) => (
                <option
                  value={dealergroup.dealerGroupID}
                  key={dealergroup.dealerGroupID}
                >
                  {`${dealergroup.dealerGroupName} - ${dealergroup.dealerGroupID}`}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex flex-col justify-center items-center my-[12px] space-y-4">
            <button
              onClick={handleConnectDealerGroup}
              className="flex items-center w-[103px] justify-around text-white bg-[#298FC2] focus:ring-4 font-bold rounded-lg text-sm px-5 py-2.5 text-center mr-2 my-2"
            >
              Submit
            </button>
            <h3 className="underline cursor-pointer">
              Bulk Dealership to Dealer Group Connections
            </h3>
          </div>
        </div>
        <div className="">
          <h3 className="font-bold text-[#586283] text-[20px] my-[20px]">
            Connect To Staff
          </h3>
          <div className="flex flex-row items-center justify-around w-[800px] space-y-6">
            <h3>Primary Dealer Consultant</h3>
            <select
              onChange={(e) => {
                setUserID(e.target.value)
                updatePrimeConsultant(+e.target.value)
              }}
              value={userID}
              className="rounded-xl w-[400px] p-[16px] focus:outline-[#58628325] ml-[15px] focus:border-none"
            >
              {filteredUsers.map((user) => (
                <option value={user.userID} key={user.userID}>
                  {`${user.firstName} ${user.lastName} - ${user.email}`}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {rightMenuCollapse ? (
        <div className="flex flex-col">
          <CollapsingButton side="right" />
          <div className="flex items-center justify-center w-[48px] h-[48px]">
            <img src={supportIcon} alt="support" />
          </div>
        </div>
      ) : (
        <div className="p-2 2xl:text-[14px] text-[12px] rounded-r-xl bg-[#FFFFFF] w-[17%]">
          <CollapsingButton side="right" />
          <Support />
        </div>
      )}
    </div>
  )
}
